import React from "react";

const Organization = () => {
  return (
    <div className="text-center py-16">
      {/* 組織図 タイトル */}
      <div className="mb-16">
        <h1 className="text-3xl font-bold text-gray-800">組織図</h1>
        <img
          src="/images/image4.png"
          alt="装飾ライン"
          className="mx-auto my-2 w-32"
        />
      </div>

      {/* 組織図 SVG の表示 */}
      <div className="flex justify-center">
        <img
          src="/images/組織図_フォント修正済み.svg"
          alt="組織図"
          className="w-full max-w-4xl md:max-w-3xl mx-auto"
        />
      </div>

      {/* 関連会社のご紹介 */}
      <div className="mb-5 mt-10">
        <h1 className="text-2xl font-bold text-gray-800">関連会社のご紹介</h1>
      </div>

      {/* グループ会社リンク */}
      <div className="mt-3 space-y-8">
        {/* アプロホールディングス株式会社 */}
        <div
          className="relative p-6 rounded-lg shadow-md overflow-hidden"
          style={{
            backgroundImage: `url(/images/ShinagawaPhoto.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="relative">
            <h2 className="text-xl font-semibold text-white">
              アプロホールディングス株式会社
            </h2>
            <p className="text-gray-200 mt-2">
              東京を中心に、当社所有の売買・賃貸物件において、その資産価値を最大限に高める管理・運用・メンテナンスをしています。
            </p>
            <a
              href="https://www.aprohd.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-300 font-semibold hover:underline block mt-2"
            >
              本社ホームページへ
            </a>
          </div>
        </div>

        {/* リラクゼーション事業 */}
        <div
          className="relative p-6 rounded-lg shadow-md overflow-hidden"
          style={{
            backgroundImage: `url(/images/SpaPhoto.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="relative">
            <h2 className="text-xl font-semibold text-white">
              リラクゼーション事業
            </h2>
            <p className="text-gray-200 mt-2">
              自社物件のテナントを活用してリラクゼーションサロンを展開。お客様に癒しとけんこうを与えることをコンセプトに取り組んでいます。
            </p>
            <a
              href="https://www.sea-terrace.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-300 font-semibold hover:underline block mt-2"
            >
              店舗サイトへ
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organization;